export const isIE = /*@cc_on!@*/ !!document.documentMode || navigator.userAgent.indexOf('Edge') >= 0;

export const cssPropertyValueSupported = (prop, value) => {
	const d = document.createElement('div');
	d.style[prop] = value;
	return d.style[prop] === value;
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
export function supportsHistory() {
	const ua = window.navigator.userAgent;
	if (
		(ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
		ua.indexOf('Mobile Safari') !== -1 &&
		ua.indexOf('Chrome') === -1 &&
		ua.indexOf('Windows Phone') === -1
	)
		return false;
	return window.history && 'pushState' in window.history;
}
